(function (angular) {
	'use strict';

	angular
		.module('scrollDownPromptModule')
		.directive('scrollDownPrompt', [
			'$timeout',
			'$window',
			'STATIC_BASE_PATH',
			scrollDownPromptFunction
		]);

	function scrollDownPromptFunction(
		$timeout,
		$window,
		STATIC_BASE_PATH) {
		return {
			replace: true,
			restrict: 'E',
			scope: {
				target: '@'
			},
			templateUrl: STATIC_BASE_PATH + '/static/html/shared/scroll-down-prompt/scroll-down-prompt.html',
			link: function(scope, elem, attr) {

				$timeout(function() {
					scope.revealed = true;
				}, 2000);

				angular.element($window).on('scroll', function() {

					var scrolled = $window.pageYOffset > 100;

					if(scope.scrolled !== scrolled) {
						scope.scrolled = scrolled;
						scope.$apply();
					}
				});
			}
		};
	}
})(window.angular);